import * as React from "react";
import { UspGroup } from "@grandvisionhq/content";
import { compose } from "@grandvisionhq/utils";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withHidableContent } from "../../../../hocs/hocs/with-hidable-content.js";
import { withBloomreachData } from "../../../../hocs/hocs/with-bloomreach-data.js";
import { withEditableContent } from "../../../../hocs/hocs/with-editable-content.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
const CmsPolicyBar = ({ content, theme = "default" }) => {
  if (!content?.policyItems?.length) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(UspGroup, { items: content.policyItems, theme });
};
const PolicyBar = compose(
  withBreakpointVisibility,
  withHidableContent,
  withBloomreachData,
  withEditableContent,
  withAnchor
)(CmsPolicyBar);
export {
  CmsPolicyBar,
  PolicyBar as default
};
//# sourceMappingURL=PolicyBar.js.map
